var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
// Material Ui
import MuiTextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import Visibility from "@mui/icons-material/Visibility";
import Favorite from "@mui/icons-material/Favorite";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { inputSxPropsFn, inputLabelSxPropsFn } from "./TextField.styles";
import { COLORS, VALIDATION_MAP } from "../../../../constants";
import Text from "../../Text";
import TooltipInfoIcon from "../../../Molecules/TooltipInfoIcon/TooltipInfoIcon";
import IconButton from "../../IconButton";
var TextField = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "text" : _b, masked = _a.masked, name = _a.name, frontAdornment = _a.frontAdornment, endAdornment = _a.endAdornment, endAdornmentClick = _a.endAdornmentClick, _c = _a.multiline, multiline = _c === void 0 ? false : _c, _d = _a.inputSize, inputSize = _d === void 0 ? "medium" : _d, InputProps = _a.InputProps, InputLabelProps = _a.InputLabelProps, _e = _a.defaultAdornmentColors, defaultAdornmentColors = _e === void 0 ? true : _e, colorSwatch = _a.colorSwatch, outerLabel = _a.outerLabel, onChange = _a.onChange, id = _a.id, value = _a.value, subOuterLabel = _a.subOuterLabel, description = _a.description, tooltip = _a.tooltip, disabled = _a.disabled, rest = __rest(_a, ["type", "masked", "name", "frontAdornment", "endAdornment", "endAdornmentClick", "multiline", "inputSize", "InputProps", "InputLabelProps", "defaultAdornmentColors", "colorSwatch", "outerLabel", "onChange", "id", "value", "subOuterLabel", "description", "tooltip", "disabled"]);
    var inputProps = {};
    var _f = __read(useState(""), 2), swatchColor = _f[0], setSwatchColor = _f[1];
    useEffect(function () {
        if (colorSwatch) {
            checkSwatch(value);
        }
    }, [value]);
    // Get padding and fontsize per inputSize
    var sizeData = (function () {
        if (inputSize === "large") {
            return {
                padding: "16.5px",
                fontSize: "16px",
                legend: "12px",
                label: "16px",
                lineHeight: "24px",
            };
        }
        if (inputSize === "medium") {
            return {
                padding: "9px",
                fontSize: "16px",
                legend: "12px",
                label: "9px",
                lineHeight: "24px",
            };
        }
        return {
            padding: "10px",
            fontSize: "14px",
            legend: "12px",
            label: "10px",
            lineHeight: "20px",
        };
    })();
    inputProps.sx = inputSxPropsFn({
        sizeData: sizeData,
        frontAdornment: !!frontAdornment,
        defaultAdornmentColors: defaultAdornmentColors,
        multiline: multiline,
        disabled: disabled,
    });
    /**
     * Masking input logic
     */
    var _g = __read(useState(false), 2), showField = _g[0], setShowField = _g[1];
    var handleClickShowPassword = function () {
        setShowField(!showField);
    };
    var handleMouseDefault = function (e) {
        e.preventDefault();
    };
    // End Mask logic
    /**
     * if masked field is set, show eye icon
     */
    if (masked) {
        inputProps.endAdornment = (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ "data-testid": "adornment-masked-toggle", "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDefault, disabled: disabled }, { children: showField ? _jsx(Visibility, {}) : _jsx(VisibilityOff, {}) })) })));
    }
    else if (endAdornment) {
        /**
         * If endAdornment is passed set endAdornment
         */
        inputProps.endAdornment = (_jsx(InputAdornment, __assign({ position: "end" }, { children: endAdornmentClick ? (_jsx(IconButton, __assign({ "data-testid": "adornment-end", "aria-label": "adornment input end", onMouseDown: handleMouseDefault, onClick: endAdornmentClick, disabled: disabled }, { children: typeof endAdornment === "string" ? (_jsx(_Fragment, { children: endAdornment })) : (endAdornment) }))) : (endAdornment) })));
    }
    /**
     * If front adornment is set, either show provided node or default heart
     */
    if (frontAdornment) {
        var adornment = frontAdornment === true ? _jsx(Favorite, {}) : frontAdornment;
        inputProps.startAdornment = (_jsx(InputAdornment, __assign({ position: "start" }, { children: adornment })));
    }
    /**
     * If front adornment is set, either show provided node or default heart
     */
    if (colorSwatch) {
        inputProps.startAdornment = (_jsx(InputAdornment, __assign({ position: "start", sx: { alignSelf: "stretch", height: "unset", maxHeight: "unset" } }, { children: _jsx(Box, { width: "40px", bgcolor: swatchColor, sx: {
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    alignSelf: "stretch",
                } }) })));
        inputProps.style = { paddingLeft: 0 };
    }
    var testid = name || type;
    var inputLabelProps = {
        sx: inputLabelSxPropsFn({ sizeData: sizeData }),
    };
    var checkSwatch = function (newValue) {
        var swatchColor = newValue && VALIDATION_MAP.hex(newValue) === true
            ? newValue
            : COLORS.P_DISABLED;
        setSwatchColor(swatchColor);
    };
    var handleChange = function (event) {
        if (onChange) {
            onChange(event);
        }
    };
    return (_jsxs(_Fragment, { children: [outerLabel && (_jsxs(InputLabel, __assign({ htmlFor: id }, InputLabelProps, { sx: __assign({ mb: 1.5 }, InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.sx) }, { children: [_jsx(Stack, __assign({ direction: "column", className: "textfield-outerlabel" }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center", height: 32 }, { children: [_jsx(Text, __assign({ variant: "body2" }, { children: outerLabel })), subOuterLabel && (_jsx(Text, __assign({ variant: "body2", category: "primary", shade: "dark", emphasis: "medium" }, { children: subOuterLabel }))), tooltip && (_jsx(TooltipInfoIcon, __assign({}, tooltip, { sx: { display: "flex" } })))] })) })), description && (_jsx(Box, __assign({ className: "textfield-description" }, { children: _jsx(Text, __assign({ variant: "body3", category: "primary", shade: "dark", emphasis: "medium" }, { children: description })) })))] }))), _jsx(MuiTextField, __assign({ id: id, InputLabelProps: inputLabelProps, type: !showField && masked ? "password" : type, InputProps: __assign(__assign({}, InputProps), inputProps), multiline: multiline, "data-testid": "input-".concat(testid), onChange: handleChange, value: value, disabled: disabled }, rest))] }));
};
export default TextField;
